export const queryKeys = {
  getLookupGroups: "getLookupGroups",
  getLookupGroup: "getLookupGroup",
};
